<template>
  <div>
    <h1>访问的资源不存在！3s后返回首页</h1>
  </div>
</template>
<script>
export default {
  name: "Error-404",
  mounted() {
    setTimeout(() => {
      this.$router.push("/");
    }, 3000);
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h1 {
  text-align: center;
  line-height: 60px;
  font: 36px bolder;
}
</style>
